import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout, retry } from 'rxjs/operators';
import { IConfig } from '../interfaces/config.interface';

@Injectable()
export class HTTPInterceptor implements HttpInterceptor {
    constructor(@Inject('config') public config: IConfig) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const verificationTokenElement = document.getElementsByName('__RequestVerificationToken');
        let verificationToken = null;
        if (verificationTokenElement && verificationTokenElement[0]) {
            verificationToken = (verificationTokenElement[0] as HTMLInputElement).value;
            request = request.clone({
                headers: new HttpHeaders({
                    __RequestVerificationToken: verificationToken
                })
            });
        }

        const retryCount = request.url.indexOf('retry') !== -1 ? (this.config.HttpCallRetries || 1) : 0;

        return next.handle(request).pipe(
            retry(retryCount),
            timeout(90000), // 90s
            catchError(err => this.handleError(err))
        );
    }

    public handleError(err) {
        // we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage: string;
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err.status}: ${err}`;
        }
        console.error(err);
        return throwError(errorMessage);
    }
}
